/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#config)
 */
export const experimentalQueryParamEncoding = false
export const clientCacheEnabledAtBuild = true
export const importMetaServer = import.meta.server
export const importMetaClient = import.meta.client